module.exports = __webpack_public_path__ + "img/screen-manual-1.7565d252.png";